import { memo } from "react";

import loadable from "@loadable/component";

const TokenDetailsApollo = loadable(
  () => import("../../features/token-details/apollo/TokenDetailsApollo")
);

const TokenDetailsSwitch = ({
  useTokenByRevealIdQuery,
}: {
  useTokenByRevealIdQuery?: boolean;
}) => {
  return (
    <TokenDetailsApollo useTokenByRevealIdQuery={useTokenByRevealIdQuery} />
  );
};

export default memo(TokenDetailsSwitch);
